var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCarbonSun = function SvgIconCarbonSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECC94B",
    d: "M12 9.004a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0-1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M4.046 5.11l1.061-1.06 2.63 2.629-1.062 1.06zM1.5 11.254h3.75v1.5H1.5zm2.545 7.645 2.63-2.63 1.06 1.06-2.628 2.63zm7.205-.145h1.5v3.75h-1.5zm5.015-1.425 1.06-1.06 2.63 2.629-1.06 1.06zm2.485-6.075h3.75v1.5h-3.75zm-2.485-4.576 2.63-2.63 1.06 1.061-2.63 2.63zM11.25 1.504h1.5v3.75h-1.5z"
  })));
};
export default SvgIconCarbonSun;